import { useState, useEffect } from 'react';

/**
 * Hook para gerenciar testes A/B
 * @param testName - Nome único do teste para armazenamento
 * @param variants - Array de variantes (ex: ['A', 'B'])
 * @returns Variante selecionada e função para resetar
 */
export const useABTest = (testName: string, variants: string[] = ['A', 'B']) => {
  const [variant, setVariant] = useState<string | null>(null);

  useEffect(() => {
    // Checa localStorage para variante existente
    const storageKey = `ab_test_${testName}`;
    const storedVariant = localStorage.getItem(storageKey);

    if (storedVariant && variants.includes(storedVariant)) {
      setVariant(storedVariant);
      console.log(`[AB-TEST] ${testName}: Restored variant ${storedVariant} from localStorage`);
    } else {
      // Randomiza 50/50
      const randomVariant = variants[Math.floor(Math.random() * variants.length)];
      localStorage.setItem(storageKey, randomVariant);
      setVariant(randomVariant);
      
      console.log(`[AB-TEST] ${testName}: Initialized with variant ${randomVariant}`);
    }
  }, [testName, variants]);

  const resetTest = () => {
    const storageKey = `ab_test_${testName}`;
    localStorage.removeItem(storageKey);
    setVariant(null);
    console.log(`[AB-TEST] ${testName}: Reset`);
  };

  return { variant, resetTest };
};
